import Vue from 'vue'

import InputButtonGroup from './InputButtonGroup.vue'
import InputCheckbox from './InputCheckbox.vue'
import InputChipBox from './InputChipBox.vue'
import InputCodeEditor from './InputCodeEditor.vue'
import InputColorPicker from './InputColorPicker.vue'
import InputCombobox from './InputCombobox.vue'
import InputCountry from './InputCountry.vue'
import InputDatePicker from './InputDatePicker.vue'
import InputFile from './InputFile.vue'
import InputIcon from './InputIcon.vue'
import InputLocale from './InputLocale.vue'
import InputSelect from './InputSelect.vue'
import InputState from './InputState.vue'
import InputSwitch from './InputSwitch.vue'
import InputText from './InputText.vue'
import InputTextarea from './InputTextarea.vue'
import InputTimePicker from './InputTimePicker.vue'
import InputTimezone from './InputTimezone.vue'
import InputWysiwyg from './InputWysiwyg.vue'

Vue.component('input-button-group', InputButtonGroup)
Vue.component('input-checkbox', InputCheckbox)
Vue.component('input-chipbox', InputChipBox)
Vue.component('input-code-editor', InputCodeEditor)
Vue.component('input-color-picker', InputColorPicker)
Vue.component('input-combobox', InputCombobox)
Vue.component('input-country', InputCountry)
Vue.component('input-date-picker', InputDatePicker)
Vue.component('input-file', InputFile)
Vue.component('input-icon', InputIcon)
Vue.component('input-locale', InputLocale)
Vue.component('input-select', InputSelect)
Vue.component('input-state', InputState)
Vue.component('input-switch', InputSwitch)
Vue.component('input-text', InputText)
Vue.component('input-textarea', InputTextarea)
Vue.component('input-time-picker', InputTimePicker)
Vue.component('input-timezone', InputTimezone)
Vue.component('input-wysiwyg', InputWysiwyg)
